import init from '@/api/common';
// 其他模块的接口……

// 导出接口
export default {
    init
    // ……
}